import { Swiper, Navigation } from 'swiper';

window.addEventListener('load', () => {
  const prevBtn = '.landscape-photos__nav--prev';
  const nextBtn = '.landscape-photos__nav--next';
  const sliderName = '.landscape-photos__swiper-container';

  function refreshTabindex() {
    const disabledLinks = this.el.querySelectorAll('.swiper-slide:not(.swiper-slide-active) a');
    disabledLinks.forEach((link) => {
      link.tabIndex = -1;
    });

    const activeLinks = this.el.querySelectorAll('.swiper-slide-active a');
    activeLinks.forEach((link) => {
      link.tabIndex = 0;
    });
  }

  function hidePrevSlides() {
    this.slides.forEach((slide, index) => {
      if (index < this.activeIndex) {
        slide.classList.add('hidden');
      } else {
        slide.classList.remove('hidden');
      }
    });
  }

  new Swiper(sliderName, {
    modules: [Navigation],
    speed: 700,
    slidesPerView: 1,
    spaceBetween: 0,
    allowTouchMove: false,
    preloadImages: true,
    navigation: {
      nextEl: nextBtn,
      prevEl: prevBtn,
    },
    on: {
      init() {
        refreshTabindex.call(this);
      },
      slideChangeTransitionEnd() {
        refreshTabindex.call(this);
      },
      slideChange() {
        hidePrevSlides.call(this);
      },
    },
  });
});
